// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"66":"sys_user","854":"sys_dept","856":"sys_job"}[chunkId] || chunkId) + "." + {"66":"8d6537f4","374":"9e6ec34f","854":"6541745e","856":"7dd767c1","874":"dc894dee"}[chunkId] + ".js";
};